import styled from 'styled-components';
import ResidentialStatus from '../../../components/fields/ResidentialStatusField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheResidentialStatusField = styled(ResidentialStatus)<Brightness>`
    ${PorscheSelectCss}
`;

const ResidentialStatusField = withPorscheSelect(PorscheResidentialStatusField);
export default ResidentialStatusField;
